import { useGetCompanyDetailsQuery } from "web/features/company/companyApiSlice";

const useIsDashboardEnabled = () => {
  const { data: company, isLoading } = useGetCompanyDetailsQuery();
  const isDashboardEnabled = company?.enableDashboard;

  return { isLoading, isDashboardEnabled };
};

export default useIsDashboardEnabled;
